<template>
    <div style="margin-left: 20px; height: 40px;" class="d-flex align-center justify-center">
        <v-autocomplete  class="input_de_pesquisa text-center" v-model="funcionarioPesquisa" :items="funcionarioLista" :loading="isLoading_"
            :search-input.sync="search" color="primary" item-text="nomeUsuario" item-value="nomeUsuario"
            label="Nome do funcionário" append-icon="search" return-object @change="selecionarEstudante()" rounded>
            <template v-slot:label>
                <label class="text-center">Nome do funcionario</label>
            </template>
        </v-autocomplete>
    </div>
</template>
  

<script>
import axios from '../../plugins/axios'
import Swal from 'sweetalert2'
const ls = require('local-storage')
export default {
    name: 'pesquisarFuncionario',
    data() {
        return {
            funcionarioPesquisa: null,
            funcionarioLista: [],
            isLoading_: false,
            search: ''
        };
    },

    computed: {
        urlImpressao() {
            return ls.get('url_impressao')
        },
    },

    watch: {
        /**
         * Método responsavél por observar sempre que o input é preenchido
         * Se o input tiver mais de suas palavras digitada, 
         * executará a função InitializarEstudanteLocal()
        */
        search(val) {
            if (val && val.length > 2) {
                this.estudantes = []
                this.InitializarEstudanteLocal(val)
            }
        }
    },

    methods: {
        /**
         * Método responsavél por carregar a lista de todos
         estudante cujo a descrição bate com o valor inserido
         * Exibe uma notificação cajo ocorra um erro
        */
        async InitializarEstudanteLocal(searchDB) {
            this.isLoading_ = true;
            let payload = null;
            this.funcionarioLista = [];
            if (searchDB) payload = '{ "find" : "' + searchDB + '" }'
            else payload = '{ "find":"all" }'
            try {
                this.funcionarioLista = await axios.get('/pesquisaFuncionarioNome/' + payload).then(res => res.data)
            } catch (error) {
                Swal.fire('Error', 'Ocorreu um erro durante a pesquisa do funcionário!', 'error');
            } finally {
                this.isLoading_ = false;
            }
        },

        /**
         * Método responsavél por enviar o estudante escolhido para o componente pai
        */
        selecionarEstudante() {
            this.$emit('estudanteEscolhido', this.funcionarioPesquisa);
        }
    }
};
</script>

<style>
.input_de_pesquisa {
    background-color: #f3eee3;
    height: 40px;
}

.redBorda {
    border: 2px dotted transparent;
    animation: flashBorder .5s linear infinite alternate;
}

@keyframes flashBorder {
    0% {
        border-color: transparent;
    }
    100% {
        border-color: #ff0000;
    }
}
</style>